import DataTaggerFormRedux from "../../../components/controls/DataTaggerFormRedux"
import { Accordion } from "../../../components/common"
import { OPERATION_MODE } from '@laramie/ui';
const InfoAdicional = ({title, entity, idEntity, mode, processKey, setPendingChange}) => {
    return (
        <Accordion title="Información adicional" className="m-top-20">
            <DataTaggerFormRedux
                title={title}
                processKey={processKey}
                entidad={entity}
                idEntidad={idEntity}
                disabled={(mode === OPERATION_MODE.VIEW)}
                onChange={(row) => setPendingChange(true)}
            />
        </Accordion>
    )
}

export default InfoAdicional